import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/homepage/tmp2_bg_poster.jpg")